import type { WidgetPublicReview } from "@shared/contracts/widgets/public/common";
import { formatWidgetAuthor } from "@shared/widgets/format";
import { escapeAttr, escapeHtml } from "../utils/escape";
import { relativeTime } from "../utils/relativeTime";
import type { Translator } from "../i18n/resolve";
import { renderStarRating } from "./starRating";

export type ReviewCardInput = {
  review: WidgetPublicReview;
  translate: Translator;
  now?: number;
  slideAttributes?: string;
};

export const renderReviewCard = ({
  review,
  translate,
  now,
  slideAttributes = "",
}: ReviewCardInput): string => {
  const stars = renderStarRating(review.rating, translate);
  const date = escapeHtml(relativeTime(review.publishedAt, translate, now));
  const comment = escapeHtml(review.comment);
  const author = escapeHtml(formatWidgetAuthor(review));
  const lang = review.locale ? ` lang="${escapeAttr(review.locale)}"` : "";
  return `<article class="mbn-review" data-review-id="${escapeAttr(review.id)}" ${slideAttributes}><div class="mbn-review-head">${stars}<time class="mbn-review-date">${date}</time></div><p class="mbn-review-body"${lang}>${comment}</p><cite class="mbn-review-author">${author}</cite></article>`;
};
